import React from 'react';
import useSelectContext, { SelectContextProvider } from './select-context';
import ValidationMessage from '~/components/validation-message/validation-message';
function HiddenSelect({ name, required, elementRef }) {
    const { item } = useSelectContext();
    return (React.createElement("select", { name: name, required: required, ref: elementRef, hidden: true }, item && React.createElement("option", { value: item.value, selected: true })));
}
function SValidationMessage({ elementRef }) {
    const { item } = useSelectContext();
    return React.createElement(ValidationMessage, { watchValue: item, elementRef: elementRef });
}
export default function Select({ name, required, onValueUpdate, children }) {
    const elementRef = React.useRef(null);
    return (React.createElement(SelectContextProvider, { contextValueParameters: { onValueUpdate } },
        React.createElement("div", { className: "Select" },
            name && React.createElement(HiddenSelect, { name, required, elementRef }),
            children),
        name && (React.createElement(SValidationMessage, { elementRef: elementRef }))));
}
